import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
    border-radius: 0.625em;
    border-left: 8px solid rgba(195, 35, 64, 0.5);
    background-color: #ffffff;
    cursor: pointer
`

const H1 = styled.h1`
    font-size: 3em;
    margin: 0;
    font-weight: 400;
    align-items: center
    display: flex
`

const H6 = styled.h6`
    font-size: 1.1em;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 0px
`
const H7 = styled.h6`
    font-size: 1.1em;
    color: rgba(0, 0, 0, 0.5);
`
const StyledRightBarTop = styled.div`
  display: flex;
  justify-content: space-between;
`;
const OverviewKpiCard = ({ title, subTitle,subview,icon, showRatingView, image, className="", title2}) => {
  return (
    <Card className={`text-left shadow-lg overview-segment-card ${className}`} style={{ padding: "10px 20px 10px 20px"}} onClick={()=> showRatingView && showRatingView()}>
      <StyledRightBarTop>
        <H1>{image &&  <img src={image} alt="Logo" style={{marginRight: 15}} />}<span>{title}</span></H1>
        {icon &&  <img src={icon} alt="Logo" />}
        </StyledRightBarTop>
        {subTitle && <H6>{subTitle}</H6>}
        {title2 && <div style={{color:"#000000", fontSize: "16px", fontWeight: 500, paddingBottom: 5}}>{title2}</div>}
        {subview && <H7>{subview}</H7>}
    </Card>
  )
}

export default OverviewKpiCard